module.exports = __webpack_public_path__ + "static/media/upload.3607a115.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/upload.svg
// module id = 507
// module chunks = 0